export enum ErrorTypes {
  MEDIA = 'media',
  API = 'api',
}
